import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CrisisRedirectBanner } from '@/components/innerworld';

export default function RestAtShorePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const showCrisis = location.state?.crisis === true;
  const lightAwarded = location.state?.lightAwarded;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6" style={{ background: '#FBF9F6' }} data-testid="rest-at-shore-screen">
      <div className="max-w-sm w-full text-center">
        <svg width="60" height="34" viewBox="0 0 60 34" fill="none" stroke="#8fa9be" strokeWidth="1.5" className="mx-auto mb-8 opacity-70">
          <path d="M2 12c5-5 10-5 15 0s10 5 15 0 10-5 15 0 8 4 11 2" />
          <path d="M2 24c5-5 10-5 15 0s10 5 15 0 10-5 15 0 8 4 11 2" />
        </svg>

        {showCrisis && <CrisisRedirectBanner />}

        <p className="text-lg leading-relaxed mb-6" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}>
          You're at the Shore now. Nothing is asked of you here.
        </p>
        <p className="text-sm leading-relaxed mb-2" style={{ fontFamily: 'Jost, sans-serif', color: 'rgba(232,180,184,0.75)' }}>
          Take one slow breath — in for 4, hold for 7, out for 8.
        </p>
        <p className="text-sm leading-relaxed mb-10" style={{ fontFamily: 'Jost, sans-serif', color: 'rgba(232,180,184,0.75)' }}>
          The ground is steady beneath you. You can stay as long as you like.
        </p>

        {typeof lightAwarded === 'number' && (
          <p className="text-xs tracking-[0.15em] mb-8" style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }} data-testid="shore-light-awarded">
            +{lightAwarded} LIGHT — YOU SHOWED UP. THAT COUNTS.
          </p>
        )}

        <button
          onClick={() => navigate('/inner-world')}
          className="px-10 py-3.5 rounded-full text-sm tracking-[0.12em] transition-all active:scale-95"
          style={{ background: 'rgba(143,169,190,0.15)', color: '#8fa9be', fontFamily: 'Jost, sans-serif' }}
          data-testid="shore-return-button"
        >
          RETURN WHEN YOU'RE READY
        </button>
      </div>
    </div>
  );
}
